import React, { useEffect, useState } from "react";
import "./code.style.scss";
import ReactCodeInput from "react-code-input";
import { Button } from "antd";
import CircularProgress from "@material-ui/core/CircularProgress";
import { toast, ToastContainer } from "react-toastify";
import { get, post, responseValidator } from "../../api";
import moment from "moment";
export default function Code(props) {
  const [loading, setLoading] = useState(false)
  const [code, setCode] = useState('')
  const [timeRemaining, setTimeRemaining] = useState(120);
  const [resend, setResend] = useState('ارسال مجدد کد');
  useEffect(() => {
    counter(119);
  }, []);

  function s_to_mmss(time = 0) {
    const second = time % 60;
    const min = Math.floor(time / 60);
    return (min < 10 ? '0' + min : min) + ':' + (second < 10 ? '0' + second : second);
  }

  function counter(value) {
    setTimeRemaining(value);
    if (value > 0) {
      setTimeRemaining(value);
      setTimeout(() => {
        counter(value - 1);
      }, 1000);
    } else {
      setTimeRemaining(120);
    }
  }

  function resendHandler() {
    setLoading(true)
    if (props.state === 5) {
      post(`/User/SendSmsCode/`, {
        "phoneNumber": localStorage.getItem('phone'),
      }).then(response => {
        console.log(response)
        setLoading(false)
        if (responseValidator(response.status)) {
          console.log(response)
          toast.success(response.data.message)
        } else
          toast.error(response.data.message);
      });
    } else {
      get(`/User/Exist/${localStorage.getItem('phone')}`).then(response => {
        setLoading(false)
        if (responseValidator(response.status)) {
          console.log(response)
          toast.success(response.data.message)
        } else
          toast.error(response.data.message);
      });
    }


    //setResend('در حال ارسال...');
    counter(119);

  }
  useEffect(() => {
    if (code.length === 5)
      onCLickHandler()
  }, [code])

  function onCLickHandler() {
    setLoading(true)

    post(`/User/${props.state === 2 ? 'ConfirmPhoneNumber' : 'ConfirmCode'}`, {
      "phoneNumber": localStorage.getItem('phone'),
      "code": code
    }).then(response => {
      setLoading(false)
      console.log(response)
      if (responseValidator(response.status)) {
        // console.log(response.data.data.access_token)
        localStorage.setItem("refToken", response.data.data.refresh_token);
        localStorage.setItem("accessToken", response.data.data.access_token);
        localStorage.setItem("roles", response.data.data.roles.toString());

        localStorage.setItem("tokenDate", moment.utc());
        if (props.state === 2)
          props.changeState(3)
        else
          props.changeState(6)
      } else
        toast.error(response.data.message);
    });
    //toast.success('صحیح')
  }

  return (
    <div className="TEMX-code">
      <h2>کد تایید را وارد نمایید</h2>
      {props.state === 2 ? <p>حساب کاربری با شماره موبایل {localStorage.getItem('phone')} وجود ندارد.
        برای ساخت حساب جدید، کد تایید برای این شماره ارسال گردید</p> : <p>کد تایید ارسال شده برای شماره {localStorage.getItem('phone')} را وارد نمایید </p>}
      <div className='code-container'>
        <ReactCodeInput onChange={(e) => setCode(e)} autoFocus type='number' fields={5} />
      </div>
      <div className="resend">
        {timeRemaining === 120 && (
          <a onClick={resendHandler} className="resending">
            {resend}
          </a>
        )}

        {timeRemaining !== 120 && (
          <a className="agn-send-again"> تا ارسال مجدد کد : {s_to_mmss(timeRemaining)} </a>
        )}
      </div>
      <div className='my-btn'>
        <Button loading={loading} disabled={code.length !== 5} block type="primary" onClick={onCLickHandler}>تایید</Button>
      </div>
      <p>شماره وارد شده متعلق به شما نیست ؟ ‌<a onClick={() => props.changeState(1)}>تصحیح شماره</a></p>

    </div>
  );
}
